export default "__VITE_ASSET__6af7db0c__"